import { useEffect, useState } from 'react';
export function usePeriodicRerender(milliseconds = 30000) {
    const [_, triggerRender] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => triggerRender((v) => v + 1), milliseconds);
        return () => clearInterval(interval);
    }, [milliseconds]);
}
